"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _makeObjectRecord = _interopRequireDefault(require("../record/makeObjectRecord"));

var _ObjectTypes = require("../constants/ObjectTypes");

var _ObjectIds = _interopRequireDefault(require("../constants/ObjectIds"));

var _default = (0, _makeObjectRecord.default)({
  idKey: _ObjectIds.default[_ObjectTypes.ENGAGEMENT],
  objectType: _ObjectTypes.ENGAGEMENT,
  recordName: 'EngagementRecord',
  defaults: {
    associations: (0, _immutable.Map)(),
    engagement: (0, _immutable.Map)(),
    metadata: (0, _immutable.Map)(),
    attachments: (0, _immutable.List)(),
    scheduledTasks: (0, _immutable.List)(),
    inviteeEmails: (0, _immutable.Set)()
  }
}, {
  primary: ['metadata.body'],
  secondary: ['metadata.text']
});

exports.default = _default;
module.exports = exports.default;